export function getTotalSeconds(timeRead) {
    const minutesInSeconds = new Date(timeRead).getMinutes() * 60;
    const seconds = new Date(timeRead).getSeconds();
    return minutesInSeconds + seconds;
  }